
import { defineComponent, PropType } from 'vue'

import {
  Analyzer,
  AnalyzerConnection,
  IssueOccurrenceFrequency,
  Maybe,
  Run,
  RunConnection
} from '~/types/types'
import { resolveNodes } from '~/utils/array'

import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'MetadataView',
  props: {
    issuesPrevented: {
      type: [String, Number] as PropType<string | number>,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultBranchName: {
      type: String as PropType<Maybe<string>>,
      default: ''
    },
    availableAnalyzers: {
      type: Object as PropType<Maybe<AnalyzerConnection>>,
      default: () => null
    },
    latestAnalysisRun: {
      type: Object as PropType<Maybe<Run>>,
      default: () => null
    },
    issueOccurrenceDistributionByIssueType: {
      type: Array as PropType<Array<IssueOccurrenceFrequency>>,
      default: () => []
    },
    runs: {
      type: Object as PropType<Maybe<RunConnection>>,
      default: () => null
    }
  },
  computed: {
    analyzers(): Array<Analyzer> {
      return resolveNodes(this.availableAnalyzers)
    },
    othersList() {
      const initialListCount = 4
      return this.analyzers.slice(initialListCount)
    },
    initialList() {
      const initialListCount = 4
      return this.analyzers.slice(0, initialListCount)
    },
    totalIssueCount(): string | number {
      // The truthy check is required while navigating to the repository page
      // since `issueOccurrenceDistributionByIssueType` can be `null` for a small time period
      const distributionEntries = this.issueOccurrenceDistributionByIssueType?.find(
        ({ key }) => key === 'all'
      )
      return shortenLargeNumber(distributionEntries?.count as number) || 0
    }
  }
})
